export default __webpack_public_path__ + "static/water-social-35dbf78fa03ec773f247b2a62209dfd4.png";